import {PureComponent} from "react"
import {Field, reduxForm} from "redux-form"
import CityTypeahead from "../../../../shared/components/Form/Field/CityTypeahead.jsx"

import CardRow from "../../../../shared/components/Styled/Card/CardRow.jsx"
import CardCol from "../../../../shared/components/Styled/Card/CardCol.jsx"
import CitiesTypeahead from "../../Form/Field/CitiesTypeahead.jsx"
import normBoolean from "../../../../shared/components/Form/Normalizer/boolean.js"
import Input from "../../../../shared/components/Form/Field/Input.jsx"

import "./MySearchExtraForm.scss"

export const name = 'MySearchExtraForm'
class MySearchExtraForm extends PureComponent {

  render() {
    return (
      <form autoComplete="off" onSubmit={this.props.handleSubmit}>
        <CardRow className="my-search-container-row search-localisation-row" gap="20px">
          <CardCol flex="1 1 50%">
            <h4 className="text-center" id="location">Localisation</h4>
            <CardRow p="35px 0 0 0" gap="10px" align="baseline" className={'search-localisation-row-first'}>
              <CardCol><label htmlFor="user.city">J'habite à</label></CardCol>
              <CardCol>
                <Field
                  label=""
                  name="user.city"
                  placeholder="Paris, Bordeaux..."
                  autocomplete="off"
                  type="text"
                  component={CityTypeahead}
                />
              </CardCol>
            </CardRow>
            <CardRow p="20px 0 0 0" direction="column" gap="10px">
              <CardCol><label htmlFor="user.work_cities">Villes où je veux travailler</label></CardCol>
              <CardCol>
                <Field
                  label=""
                  name="user.work_cities"
                  placeholder="Paris, Bordeaux..."
                  autocomplete="off"
                  type="text"
                  component={CitiesTypeahead}
                />
              </CardCol>
            </CardRow>
            <CardRow p="20px 0 0 0" gap="10px" direction="row" >
              <CardCol>
                <Field
                  label=""
                  name="freelance.relocation_long_fulltime"
                  type="checkbox"
                  normalize={normBoolean}
                  component={Input}
                />
              </CardCol>
              <CardCol>
                <label htmlFor="user.city">Mobilité France entière</label>
              </CardCol>
            </CardRow>
          </CardCol>

          <CardCol flex="1 1 50%">
            <p className="title" id="tjm"> Rémunération</p>
            <CardRow className="remuneration-row" direction="column" gap="10px">
              <CardCol>
                <h6 className="text-center">TJM</h6>
                <p className="txt">Taux journalier minimum en deçà duquel nous ne vous solliciterons pas :</p>
              </CardCol>
              <CardCol>
                <Field
                  label=""
                  name="freelance.price"
                  type="number"
                  component={Input}
                />
              </CardCol>
              <CardCol>
                <h6 className="text-center">Equivalent brut annuel</h6>
                <p className="txt">
                  Si vous n’avez pas déterminé de TJ, indiquez le montant équivalent en brut annuel que vous percevez/souhaitez percevoir :</p>
              </CardCol>
              <CardCol>
                <Field
                  label=""
                  name="freelance.yearly_brut"
                  type="number"
                  component={Input}
                />
              </CardCol>
            </CardRow>
          </CardCol>
        </CardRow>
      </form>
    )
  }
}

const ReduxMySearchExtraForm = reduxForm({
  form: name,
})(MySearchExtraForm)
export default ReduxMySearchExtraForm